<template>
    <EditEtudiant />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditEtudiant from "@/components/Etudiant/EditEtudiant.vue";
  
    export default defineComponent({
      name: "EditEtudiantPage",
      components: {
        
        EditEtudiant,
      },
    });
  </script>